<template functional>
  <b-row :class="{ 'mb-3': !props.noMarginBottom }">
    <b-col class="py-2 bg-primary text-white font-weight-bold">
      <slot />
    </b-col>
  </b-row>
</template>
<script>
export default {
  functional: true,

  props: {
    noMarginBottom: {
      type: Boolean,
      defaul: false
    }
  }
}
</script>
